<script>
  import { accountRouteSection } from './account-route.js';
</script>

<section class="route" aria-label="Дата, место и связь">
  {#each accountRouteSection.cards as card}
    <article class="route-card">
      <span class="route-icon" aria-hidden="true">
        {#if card.icon === 'calendar'}
          <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="3" y="5" width="18" height="16" rx="2" stroke="currentColor" stroke-width="2"/>
            <path d="M3 9h18M8 3v4M16 3v4" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
          </svg>
        {:else if card.icon === 'pin'}
          <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 22s7-7.58 7-13a7 7 0 1 0-14 0c0 5.42 7 13 7 13Z" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/>
            <circle cx="12" cy="9" r="2.5" stroke="currentColor" stroke-width="2"/>
          </svg>
        {:else if card.icon === 'chat'}
          <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M4 5h16v11H8l-4 4V5Z" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/>
          </svg>
        {/if}
      </span>
      <h3>{card.title}</h3>
      <p>{card.description}</p>
    </article>
  {/each}
</section>

<style>
  .route {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 16px;
  }

  .route-card {
    padding: 20px;
    border: 1px solid rgba(255, 255, 255, 0.1);
    border-radius: 16px;
    background: rgba(255, 255, 255, 0.02);
  }

  .route-icon {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 36px;
    height: 36px;
    border-radius: 12px;
    background: rgba(255, 255, 255, 0.04);
    color: rgba(255, 255, 255, 0.6);
  }

  .route-icon svg {
    width: 20px;
    height: 20px;
  }

  h3 {
    margin: 16px 0 0;
    color: #ffffff;
    font-size: 16px;
    font-weight: 600;
    line-height: 1.3;
  }

  p {
    margin: 8px 0 0;
    color: rgba(255, 255, 255, 0.55);
    font-size: 14px;
    line-height: 20px;
  }

  /* ≤1279 — две карточки в ряд, третья снизу */
  @media (max-width: 1279px) {
    .route {
      grid-template-columns: repeat(2, minmax(0, 1fr));
    }
  }

  /* ≤767 — в столбик */
  @media (max-width: 767px) {
    .route {
      grid-template-columns: 1fr;
      gap: 12px;
    }
  }
</style>
